/**
 * ResearchSkeleton Component
 * Feature 014: Unified Multi-AI Post Generation Flow
 * T045: Loading skeleton for research phase
 */

import { memo } from 'react';

const ResearchSkeleton = () => {
  return (
    <div className="w-full rounded-lg border border-gray-200 bg-white p-6">
      <div className="mb-4 flex items-center gap-3">
        <div className="h-5 w-5 animate-pulse rounded-full bg-blue-100" />
        <div className="h-5 w-48 animate-pulse rounded bg-gray-200" />
      </div>

      <div className="space-y-3">
        <div className="h-4 w-full animate-pulse rounded bg-gray-100" />
        <div className="h-4 w-full animate-pulse rounded bg-gray-100" />
        <div className="h-4 w-3/4 animate-pulse rounded bg-gray-100" />
        <div className="h-4 w-full animate-pulse rounded bg-gray-100" />
        <div className="h-4 w-5/6 animate-pulse rounded bg-gray-100" />
      </div>
    </div>
  );
};

export const ResearchSkeletonMemo = memo(ResearchSkeleton);
